<template>
  <StrokeButton type="primary" :loading="isLoading" @click="getCSV">
    {{ $t('ADVERTISEMENT.BIDS.EXPORT_CSV') }}
  </StrokeButton>
</template>

<script>
import FileSaver from 'file-saver';
import StrokeButton from '@@/advertisement/common/StrokeButton';
import { AdBid } from '@/api/api';
import campaignId from '@/mixins/advertisement/campaignId';

export default {
  name: 'BidsContentExportCSV',
  components: {
    StrokeButton,
  },
  mixins: [campaignId],
  props: {
    range: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    getCSV() {
      this.isLoading = true;
      return AdBid.getBidsCSV({
        campaignId: this.campaignId,
        range: this.range,
      })
        .then(file => {
          FileSaver.saveAs(file, file.name);
        })
        .catch(({ message }) => {
          this.$message.error(message);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
